'use client';

import { c as _c } from "react/compiler-runtime";
import { Checkbox, type CheckboxProps } from 'design-system/client';
import { forwardRef } from 'react';
import ErrorMessage from '../ErrorMessage';
const FormCheckbox = forwardRef<HTMLInputElement, CheckboxProps>(function FormCheckbox(t0, ref) {
  const $ = _c(14);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const id = props.id ?? props.name;
  let t1;
  if ($[3] !== children || $[4] !== id || $[5] !== props || $[6] !== ref) {
    t1 = <Checkbox {...props} ref={ref} id={id}>{children}</Checkbox>;
    $[3] = children;
    $[4] = id;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== props.name) {
    t2 = <ErrorMessage name={props.name} />;
    $[8] = props.name;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== props.className || $[11] !== t1 || $[12] !== t2) {
    t3 = <div className={props.className}>{t1}{t2}</div>;
    $[10] = props.className;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
});
export default FormCheckbox;